<template>
    <a class="conditional-link"
            :href="path"
            :title="label"
            v-if="isEmail">
        <slot><span v-text="label"/></slot>
    </a>
    <a class="conditional-link"
            target="_blank"
            rel="noopener noreferrer"
            :href="path"
            :title="label"
            v-else-if="isExternal">
        <slot><span v-text="label"/></slot>
    </a>
    <router-link :to="{ path }" :title="label" v-else-if="isRouterLink">
        <slot><span v-text="label"/></slot>
    </router-link>
    <span v-else>
        <slot><span v-text="label"/></slot>
    </span>
</template>

<script>
    export default {
        props: {
            path: {
                type: String,
                default: '',
            },
            label: {
                type: String,
                default: '',
            },
            external: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            isRouterLink() {
                return !!(this.path && !this.isEmail);
            },
            isEmail() {
                return !!(this.path && /^mailto:.*/.test(this.path));
            },
            isExternal() {
                return this.external;
            },
        },
    };
</script>
